/* eslint-disable no-nested-ternary */
import React from 'react';
import Permissions from 'react-redux-permissions';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styles from './shortcuts.module.scss';

export default function Shortcuts({ links, currentPath }) {
  return (
      <div className={`${styles.shortcuts} main-header`}>
        {links && links.map((l) => {
          const isActive = l.url === currentPath || currentPath.startsWith(`${l.url}/`);
          return (
            l.redirect && l.permissions ? (
              <Permissions key={`${l.name}_${l.url}`} allowed={[...l.permissions]}>
                <a href={l.url} target="_blank" rel="noopener noreferrer">
                  <FormattedMessage id={l.name} defaultMessage={l.key} />
                </a>
              </Permissions>
            ) : (
              l.permissions ? (
                <Permissions key={`${l.name}_${l.url}`} allowed={[...l.permissions]}>
                  <Link key={l.name} to={l.url}>{l.name}</Link>
                </Permissions>
              )
                : <Link key={`${l.name}_${l.url}`} to={l.url} className={isActive && styles.active}>{l.name}</Link>
            )
          );
        })}
      </div>
  );
}
